import { List } from "DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization/ObjSerUtils";
import { NetViewTreeNodeDto } from "./NetViewTreeNodeDto";
import { ValueEncoder } from "DiscoveryEngine.TS/Utils";

export class NetViewDto extends NetViewTreeNodeDto {

	public NetViewGuids: List<string>;
	public AgentGuids: List<string>;
	public AwolClientAgents_Enabled: boolean;
	public AwolClientAgents_Days: number;
	public AwolClientAgents_Hours: number;
	public AwolClientAgents_Minutes: number;

	constructor() {
		super();

		this.NetViewGuids = new List<string>();
		this.AgentGuids = new List<string>();
		this.AwolClientAgents_Enabled = false;
		this.AwolClientAgents_Days = 0;
		this.AwolClientAgents_Hours = 0;
		this.AwolClientAgents_Minutes = 0;
	}

	public get HasNetViews(): boolean {
		return (this.NetViewGuids && this.NetViewGuids.Count > 0);
	}

	public get HasAgents(): boolean {
		return (this.AgentGuids && this.AgentGuids.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.net_view = {};
		obj = obj.net_view;

		super.Write(obj, context);

		if (this.HasNetViews) {
			obj.net_view_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.net_view_guids, this.NetViewGuids, context);
		}

		if (this.HasAgents) {
			obj.agent_guids = [];
			ObjSerUtils.WriteStringValueCollection(obj.agent_guids, this.AgentGuids, context);
		}

		obj.awol_client_agents_enabled = ValueEncoder.EncodeBoolean(this.AwolClientAgents_Enabled);
		obj.awol_client_agents_days = ValueEncoder.EncodeInteger(this.AwolClientAgents_Days);
		obj.awol_client_agents_hours = ValueEncoder.EncodeInteger(this.AwolClientAgents_Hours);
		obj.awol_client_agents_minutes = ValueEncoder.EncodeInteger(this.AwolClientAgents_Minutes);
	}

	public Read(obj: any, context: any): void {
		if (!obj.net_view)
			throw new Error();
		obj = obj.net_view;

		super.Read(obj, context);

		if (obj.net_view_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.net_view_guids, this.NetViewGuids, context);
		}
		if (obj.agent_guids !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.agent_guids, this.AgentGuids, context);
		}
		if (obj.awol_client_agents_enabled !== undefined) {
			this.AwolClientAgents_Enabled = ValueEncoder.DecodeBoolean(obj.awol_client_agents_enabled);
		}
		if (obj.awol_client_agents_days !== undefined) {
			this.AwolClientAgents_Days = ValueEncoder.DecodeInteger(obj.awol_client_agents_days);
		}
		if (obj.awol_client_agents_hours !== undefined) {
			this.AwolClientAgents_Hours = ValueEncoder.DecodeInteger(obj.awol_client_agents_hours);
		}
		if (obj.awol_client_agents_minutes !== undefined) {
			this.AwolClientAgents_Minutes = ValueEncoder.DecodeInteger(obj.awol_client_agents_minutes);
		}
	}

}
